import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next/";
import classnames from "classnames";
import { useSnapshot } from "valtio";
import { mutate } from "swr";
import { CheckboxIcon } from "@aureskonnect/react-ui";
import { toast } from "react-toastify";
import { uuid } from "uuidv4";
import store, { setGlobalDataIsUpdated, setKey } from "./store";

import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import { generalConfigStore } from "@store";
import { ID_SALE_SUPPORT_KIOSK } from "@constants/index";
import { useFetchGlobal } from "../../api/hooks";

type DropdownStatusType = {
    state: string;
    typeDisplay: string;
    data: any;
    franchiseID: string;
};

export function DropdownStatus({
    state,
    typeDisplay,
    data,
    franchiseID,
}: DropdownStatusType) {
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();

    const { itemsDisable } = useSnapshot(generalConfigStore);
    const [lastState, setLastState] = useState<string>(t(data.Statut));
    // eslint-disable-next-line
    const [, setStatusValue] = React.useState<string>(t(data.Statut));
    const { isAddAppClicked } = useSnapshot(store);
    const [color1, setColor1] = useState<string>();
    const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = () => setIsOpen(!isOpen);

    const handleItemClick = (status: any) => {
        ClickEventEdit(data, status);
        setIsOpen(false);
    };

    useEffect(() => {
        if (data.Application !== "") {
            if (data.Statut !== undefined) {
                setStatusValue(data.Statut);
                setLastState(data.Statut);
                if (data.Statut === "In line" || data.Statut === "En ligne") {
                    setColor1("success");
                } else {
                    setColor1("danger");
                }
            } else {
                setStatusValue(data.Status);
                setLastState(data.Status);
                if (data.Status === "In line" || data.Status === "En ligne") {
                    setColor1("success");
                } else {
                    setColor1("danger");
                }
            }
        }

        // eslint-disable-next-line
    }, [state, t]);
    // useEffect(() => {
    //     if (data.Statut !== undefined && data.Statut !== "")
    //         setLastState(StatusValue);
    // }, [StatusValue, t, state]);
    async function ClickEventEdit(data: any, text: any) {
        if (text !== undefined && text !== data.Statut) {
            setStatusValue(text);
            setLastState(text);

            if (text === "In line") {
                setColor1("success");
            } else {
                setColor1("danger");
            }

            let apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/application/modifstate`;
            try {
                const result: any = await fetchGlobal(apiUrl, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        franchiseId: franchiseID,
                        shopId: data.shopId,
                        applicationId: data.appId,
                        val: text,
                        nameKiosk: data.appName,
                    }),
                    method: "POST",
                });
                if (data.error) {
                    throw Error("Error while saving selection!");
                }
                mutate(apiUrl, result);
                setKey(uuid());
                setGlobalDataIsUpdated(true);
                toast.success(`${t("modification made successfully")!}`, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                    theme: "colored",
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    icon: <CheckboxIcon height={25} width={25} fill="white" />,
                });
            } catch (e: any) {
                console.log(`${t("There's an error")}!`);
            }
        }
    }
    if (data.Application !== "") {
        return (
            <div
                className={classnames("dropdown", {
                    "not-allowed-icon__clz":
                        isAddAppClicked || typeDisplay === "archived",
                    show: isOpen,
                })}
                key="Success"
            >
                <button
                    id="dropdown-split-variants-Success"
                    className={`btn btn-sm btn-${color1} afa_btn_statusApplication dropdown-toggle`}
                    onClick={toggleDropdown}
                    aria-expanded={isOpen}
                    type="button"
                >
                    {t(lastState)}
                </button>
                {isOpen && (
                    <div className="dropdown-menu show afa_drp_optionStatusApplication">
                        <div
                            className="dropdown-item afa_txt_onlineStatusApplication"
                            onClick={() => {
                                if (
                                    itemsDisable.find(
                                        (element: any) =>
                                            element.id ===
                                                ID_SALE_SUPPORT_KIOSK &&
                                            element.shopId === data.shopId
                                    ) !== undefined
                                ) {
                                    toast.info(
                                        `${t(
                                            "Warning: You cannot put the Kiosk application online as long as the Kiosk sales support is disabled in the general settings."
                                        )}`,
                                        {
                                            position: toast.POSITION.TOP_CENTER,
                                            autoClose: 2000,
                                            theme: "colored",
                                            closeOnClick: true,
                                            pauseOnHover: true,
                                            draggable: true,
                                            icon: (
                                                <CheckboxIcon
                                                    height={25}
                                                    width={25}
                                                    fill="white"
                                                />
                                            ),
                                        }
                                    );
                                } else {
                                    handleItemClick("In line");
                                }
                            }}
                        >
                            {t("In line")}
                        </div>
                        <div
                            className="dropdown-item afa_txt_offlineStatusApplication not-allowed-icon__clz"
                            onClick={() => {
                                handleItemClick("Offline");
                            }}
                        >
                            {t("Offline")}
                        </div>
                        <div
                            className="dropdown-item afa_txt_standbyStatusApplication"
                            onClick={() => {
                                handleItemClick("Standby state");
                            }}
                        >
                            {t("Standby state")}
                        </div>
                    </div>
                )}
            </div>
        );
    } else {
        return <div></div>;
    }
}
